<section class="client-management execute-order-details-container">

    <div class="row">
        <div class="col-md-12">
            <app-breadcrumb [title]="'ORDERMANAGEMENT.MENUHOME'" [title3]="'ExecuteOrder.MENUTitle'">
            </app-breadcrumb>

        </div>
        <div class="col-md-12">
            <div class="table-content box-style">
                <div class="table-heading">
                    <h3 style="font-weight: 600"><span> {{'ExecuteOrder.ManageOrderDetail'| translate}}</span>
                    </h3>
                </div>

                <div class="shadow-none company-info">
                    <div class="company-details">
                        <div class="detail-wrapper bg-grey row">
                            <div class="custom-detail-box col-md-2">
                                <label>{{'ExecuteOrder.OrderName'| translate}}</label>
                                <p>{{orderDetails?.orderName ? orderDetails?.orderName : '-'}}
                                </p>
                            </div>
                          
                            <div class="custom-detail-box col-md-2">
                                <label>{{'ExecuteOrder.ProjectManager'| translate}}</label>
                                <p>{{orderDetails?.projectManager ? orderDetails?.projectManager.name : '-'}}
                                </p>
                            </div>
                            <div class="custom-detail-box col-md-3">
                                <label>{{'ExecuteOrder.ExpectedTimeToComplete'| translate}}</label>
                                <p>{{orderDetails?.completionTime ? (orderDetails?.completionTime | date :
                                    'dd/MM/yyyy')
                                    : '-'}}
                                </p>
                            </div>
                            <div class="custom-detail-box col-md-3">
                                <label>  {{'ExecuteOrder.ActualCompletionTimeline'| translate}} </label>
                                <p>{{orderDetails?.actualCompletionTime ? (orderDetails?.actualCompletionTime | date : 'dd/MM/yyyy') : '-'}}
                                </p>
                            </div>
                            <div class="custom-detail-box col-md-2">
                                <span *ngIf="orderDetails?.status === executeOrderStatus.NotStarted"
                                    class="btn-style table-btn theme-line-btn sm-btn mt-1">
                                    {{'ExecuteOrder.NotStarted' | translate}}
                                </span>
                                <span *ngIf="orderDetails?.status === executeOrderStatus.InProgress"
                                    class="btn-style in-progress label-btn sm-btn table-btn mt-1">
                                    {{'ExecuteOrder.InProgress' | translate}}
                                </span>
                                <span *ngIf="orderDetails?.status === executeOrderStatus.Completed"
                                    class="btn-style active abel-btn sm-btn table-btn mt-1">
                                    {{'ExecuteOrder.Completed' | translate}}
                                </span>
                                <span *ngIf="orderDetails?.status === executeOrderStatus.Assigned"
                                    class="btn-style active abel-btn sm-btn table-btn mt-1">
                                    {{'ExecuteOrder.Assigned' | translate}}
                                </span>
                            </div>
                          
                        </div>
                       
                    </div>
                    <div class="common-tabbing manage-order-tab mt-4">
                        <mat-tab-group animationDuration="0ms">
                          
                            <mat-tab label="{{'ExecuteOrder.Task' | translate}}"><app-order-task-detail (refreshEvent)="onRefresh()"
                                    *ngIf="orderDetails" [orderDetails]="orderDetails"></app-order-task-detail>
                            </mat-tab>
                 
                        </mat-tab-group>
                    </div>
                </div>

            </div>
        </div>
        
    </div>
</section>